/*eslint-disable*/
const defaultCombiningPercents = require('./combiningPercents.json');
const TRIES_LIMIT = 10;
const MIN_ARR_LGTH_OF_DIGIT_CAP = 2;
const TRIES_LIMIT_FOR_INTERIM_ANSWERS = 8;

export default {
  data () {
    return {
      interimOperations: [],
    }
  },
  methods: {
    generateAnzanNumbers() {
      this.numbers = [];
      let digit = this.parameters.difficult;
      if (this.parameters.fractions) {
        digit += +this.parameters.fractionalPart;
      }
      if (this.parameters.mirror) {
        digit = 1;
      }
      if (this.parameters.roundNumbers && this.parameters.difficult !== 1) {
        digit -= 1;
      }
      let amountOfActions = +this.parameters.amountOfActions;
      let num;
      let correctAnswer;
      let prevCorrectAnswer = this.correctAnswer;
      if (this.parameters && this.parameters.interimAnswers) {
        this.interimOperations = (new Array(this.parameters.amountOfActions)).fill(0).map((operation, operationIndex) => {
          return operationIndex < 1 || operationIndex >= this.parameters.amountOfActions - 1
              ? 0
              : 1;
        });
      }
      do {
        this.numbers = [];
        correctAnswer = 0;
        for (let i = 0; i < amountOfActions; i++) {
          let prevNum = num;
          num = null;
          let tries = 0;
          while (!num || tries < TRIES_LIMIT) {
            tries++
            num = this.generateNumberForAnzan(digit, prevNum, correctAnswer);
          }
          if (!num) {
            i--;
            continue;
          }
          correctAnswer = +(correctAnswer + num).toFixed(2);
          this.numbers.push(num);
        }
      } while (prevCorrectAnswer === correctAnswer || !this.isSumSignRight(this.numbers));
      this.correctAnswer = correctAnswer;
    },
    generateNumberForAnzan(digitCapacity, prevNumber, currentSum) {
      let triesCounter = 0;
      let jumpOver = this.getJumpOver();
      if (Math.abs(currentSum) % jumpOver === 0
        || (Math.abs(currentSum) % 10 === 0 && Math.abs(currentSum) < jumpOver)
        || (Math.abs(prevNumber) % jumpOver === jumpOver - 1 && Math.abs(currentSum) % jumpOver === 1)
        || Math.abs(currentSum) % jumpOver === jumpOver - 1
        || (jumpOver > 50 && !this.parameters.combining
          && ((currentSum > jumpOver - 10 && currentSum < jumpOver)
            || (currentSum > -jumpOver && currentSum < -jumpOver + 10)))
        || Math.abs(currentSum) % jumpOver === 1
        || (Math.abs(prevNumber) % 10 === 9 && Math.abs(currentSum) % 10 === 1)
        || (Math.abs(prevNumber) % 10 === 9 && Math.abs(currentSum) % 10 === 8)
        || (this.onlyPositiveAnswers && currentSum < jumpOver + 100
          && ((!this.parameters.combining && currentSum % jumpOver >= jumpOver - 10)
            || currentSum % 10 === 0))
        || (this.onlyNegativeAnswers && Math.abs(currentSum) < jumpOver + 100
          && ((!this.parameters.combining && Math.abs(currentSum) % jumpOver >= jumpOver - 10)
            || Math.abs(currentSum) % 10 === 0))) {
        jumpOver = null;
      }
      let jumpDown;
      if (jumpOver) {
        let upOnly = (currentSum > 0 && currentSum % 10 === 9)
          || (currentSum < 0 && Math.abs(currentSum) % 10 === 0)
          || (!this.parameters.combining
            && ((currentSum > 0 && currentSum % jumpOver < 10)
              || (currentSum < 0 && Math.abs(currentSum) % jumpOver >= jumpOver - 10)))
          || (jumpOver > 50 && currentSum > 0 && currentSum < jumpOver)
          || (this.onlyPositiveAnswers && currentSum < jumpOver + 100);
        let downOnly = (currentSum > 0 && currentSum % 10 === 0)
          || (currentSum < 0 && Math.abs(currentSum) % 10 === 9)
          || (!this.parameters.combining
            && ((currentSum > 0 && currentSum % jumpOver >= jumpOver - 10)
              || (currentSum < 0 && Math.abs(currentSum) % jumpOver < 10)))
          || (jumpOver > 50 && currentSum < 0 && Math.abs(currentSum) < jumpOver)
          || (this.onlyNegativeAnswers && Math.abs(currentSum) < jumpOver + 100);
        jumpDown = !upOnly && (downOnly || Math.random() > 0.5);
      }
      let generatedNumber;
      let generatedInteger;
      if (this.parameters.combining) {
        let changedCombiningPercents = this.changeCombiningPercents();
        digitCapacity = this.generateCurrentDigitsLimit(digitCapacity, changedCombiningPercents);
      }
      let allowLessCapacity = this.parameters.fractions && (digitCapacity - +this.parameters.fractionalPart) === 1;
      let generatedNumbersArray = [];
      do {
        if (jumpOver) {
          let dec;
          let minUnit;
          if ((currentSum > 0 && jumpDown) || (currentSum < 0 && !jumpDown)) {
            dec = Math.floor((Math.abs(currentSum) % jumpOver) / 10) * 10;
            if (jumpOver <= 50 && Math.abs(currentSum) % 100 < jumpOver) {
              dec += jumpOver;
            }
            minUnit = Math.abs(currentSum) % 10 + 1;
          } else {
            dec = Math.floor((jumpOver - 1 - Math.abs(currentSum) % jumpOver) / 10) * 10;
            if (jumpOver <= 50 && Math.abs(currentSum) % 100 > jumpOver) {
              dec += jumpOver;
            }
            minUnit = 10 - Math.abs(currentSum) % 10;
          }
          let maxUnit = 9;
          let unit = minUnit + Math.floor(Math.random() * (maxUnit + 1 - minUnit));
          generatedNumber = Math.floor(Math.random() * Math.pow(10, digitCapacity) / 100) * 100;
          if (jumpDown) {
            generatedNumber = -generatedNumber - dec - unit;
          } else {
            generatedNumber = generatedNumber + dec + unit;
          }
        } else {
          generatedNumber = Math.floor(Math.random() * Math.pow(10, digitCapacity));
          generatedNumber = Math.random() > 0.5 ? generatedNumber : -generatedNumber;
        }
        if (generatedNumber < 0 && this.numbers.length === 0) {
          generatedNumber = -generatedNumber;
        }
        if (this.onlyNegativeAnswers && this.numbers.length === 1) {
          if (generatedNumber > 0) {
            generatedNumber = -generatedNumber;
          }
        }
        generatedInteger = generatedNumber;
        if (this.parameters.fractions) {
          generatedNumber /= Math.pow(10, +this.parameters.fractionalPart);
        }
        if (this.parameters.roundNumbers) {
          generatedNumber *= 10;
        }
        if (this.parameters.mirror) {
          let reminder;
          for (let i = 1; i < this.parameters.difficult; i++) {
            reminder = generatedNumber % 10;
            generatedNumber *= 10;
            generatedNumber += reminder;
          }
        }
        if (this.parameters.interimAnswers) {
          generatedNumbersArray.push(generatedNumber);
          if (triesCounter > TRIES_LIMIT_FOR_INTERIM_ANSWERS && generatedNumbersArray.length !== 0) {
            let helpNumber = generatedNumbersArray.find(num => {
              return this.isSumSignRight([num, currentSum], triesCounter);
            })
            generatedNumber = helpNumber !== undefined ? helpNumber : generatedNumber;
          }
        }

        triesCounter++;
      } while (
          (generatedNumber === 0 || generatedNumber === prevNumber || generatedNumber === -prevNumber
            || (!allowLessCapacity && Math.abs(generatedInteger).toString().length !== digitCapacity)
            || !this.isSumSignRight([generatedNumber, currentSum], triesCounter)
          )
          && triesCounter < TRIES_LIMIT
        );
      if (triesCounter >= TRIES_LIMIT) {
        return null;
      }
      return generatedNumber;
    },
    isSumSignRight(numbers, triesCounter = null) {
      if (this.interimOperations && this.interimOperations[this.numbers.length]) {
        if (triesCounter && triesCounter > TRIES_LIMIT_FOR_INTERIM_ANSWERS) {
          return numbers[1] > 0 && _.sum(numbers) < numbers[1]
              || numbers[1] < 0 && _.sum(numbers) > numbers[1];
        }
        return _.sum(numbers) > 0 && numbers[1] < 0
              || _.sum(numbers) < 0 && numbers[1] > 0
      } else {
        if (this.parameters.negativeAnswers && this.parameters.positiveAnswers) {
          return true;
        }
        if (this.parameters.positiveAnswers) {
          return _.sum(numbers) > 0;
        }
        if (this.parameters.negativeAnswers) {
          return _.sum(numbers) < 0 || this.numbers.length < 2;
        }
      }
    },
    getJumpOver() {
      if (!this.parameters.jumpOver50 && !this.parameters.jumpOver100) {
        return null;
      }
      let percent = 80;
      let randomPercent = Math.floor(Math.random() * 100);
      if (this.parameters.jumpOver50 && this.parameters.jumpOver100) {
        if (randomPercent > percent) {
          return null;
        }
        if (randomPercent > percent/2) {
          return 100;
        }
        if (randomPercent < percent/2) {
          return 50;
        }
      }
      if (this.parameters.jumpOver50) {
        return randomPercent <= percent ? 50 : null;
      }
      if (this.parameters.jumpOver100) {
        return randomPercent <= percent ? 100 : null;
      }
    },
    generateCurrentDigitsLimit (digitsLimit, combiningPercents) {
      let currentDigitsLimit;
      if (this.parameters.fractions) {
        digitsLimit -= +this.parameters.fractionalPart;
      }
      let randomPercent = Math.floor(Math.random() * 100);
      let remainingPercent = 100;
      for (let i = digitsLimit; i > 0; i--) {
        if (randomPercent >= (remainingPercent -= combiningPercents[digitsLimit][i])) {
          currentDigitsLimit = i;
          if (this.parameters.fractions) {
            currentDigitsLimit += +this.parameters.fractionalPart;
          }
          return currentDigitsLimit;
        }
      }
    },
    changeCombiningPercents() {
      let combiningPercents = _.cloneDeep(defaultCombiningPercents);
      let capacityLimit = this.parameters.difficult;
      if (this.parameters.combiningDigitCapacities.length >= MIN_ARR_LGTH_OF_DIGIT_CAP) {
        let capacitiesWhichNeedToResetChance = _.difference(
          _.map(
            _.keys(combiningPercents[capacityLimit]), (key) => {
              return +key;
            }
          ),
          this.parameters.combiningDigitCapacities
        );
        if (capacitiesWhichNeedToResetChance.length) {
          capacitiesWhichNeedToResetChance.forEach((capacity) => {
            combiningPercents[capacityLimit][capacity] = 0;
          });
          let newChancePercents = _.values(_.cloneDeep(
            defaultCombiningPercents[this.parameters.combiningDigitCapacities.length]
          ));
          this.parameters.combiningDigitCapacities.forEach((capacity, index) => {
            combiningPercents[capacityLimit][capacity] = newChancePercents[index];
          });
        }
      }
      return combiningPercents;
    }
  },
  computed: {
    onlyPositiveAnswers() {
      return this.parameters.positiveAnswers && !this.parameters.negativeAnswers;
    },
    onlyNegativeAnswers() {
      return this.parameters.negativeAnswers && !this.parameters.positiveAnswers;
    }
  }
}
